module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAA7CAYAAACkPdDxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBpdCNDYIwEIbhehMwAm7CBq7gBroB7STiCE4gozCCG+iVCCmlP3cflzSUNg9vgrHWdgYc4tUbcDzu0Dr9n1B9wVCdgr26HmJ1naJ3VT3GqjolzsT1FBbXKXMuquewqE6Fu4c5gFuuXw2I/fRHcLFew8W6BGfrEjzX+QMNiltedxT7ucV1DW7iugbv6lq8qWvxpo7gtX7ir3yNfj68zkh5raPYz+UIfqF44jWg+Mk/ekLwxND6DYLdstFiXx1Q7MIXDd5UtdjFB1K8q2qwSx1KcLIqxS53UcPZqgS70iWh1RouVku4Wi3hajWHRdUcFlVTWFxNYXE1xqOmGmNVNcS+OhrlEFqdh4tvAw7BVZ4fA1lZAihDXPwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/polygon-right.png
// module id = U4CO
// module chunks = 1